export const environment = {
  production: false,
  webUrl: 'https://dev-app.seemylegacy.com',
  apiUrl: 'https://sml-api-dev-dsddhdducjfnbscv.eastus-01.azurewebsites.net/',
  authPath: 'https://apigateway.sml.com/auth/token',
  googleAPI:'AIzaSyDDDZbuHM-69n-mGonMR2C_3GAXCl7dXZs',
  stripePublishableKey: 'pk_test_51PJIvWP5SR9ZDLAg50sN1WQJCJ9ebvX5z42DdnG2IwsA7S1jGeAHGHGe8XXfhCjU1WUb9sOaQF9h96puZkN8O9Mi00LQV7IM5i',
  surveyJsKey: 'MGY5MTZlMTctYzk2My00OTQ0LTk4ZDktMDQ2NDZmNzY0NjM0OzE9MjAyNi0wNi0wNQ==',
  appVersion: `1.0.0`,
  name: 'dev',
  hideColumns:true,
  allowedEmailsForTemplateActions: [
    'varun.saraswat+11c@taazaa.com',
    'sandeepn@taazaa.com',
    'akashsangal006@yopmail.com',
    'varun.saraswat+7a@taazaa.com',
    "abhijat.singh@taazaa.com"
  ]
};
